import React, { useEffect } from 'react';
import Modal from 'react-modal';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/styles';
import { DialogActions, Button, DialogTitle, DialogContent, DialogContentText, Dialog } from '@material-ui/core';
import { CancelSubmitButton } from './Main/Res/BaseButton';


function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles(theme => ({
  progress: {
    margin: '0px',
    justifyContent: 'center',
    color: '#ffffff'

  },
  paper: {
    position: 'absolute',
    width: 45,
    backgroundColor: '#33000000',
    outline: 'none',
  },
}));

export function DailogHtml({ isOpen = false, sOpen, title = <></>, content = <></>, action = <></> }) {
  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState('paper');
  const descriptionElementRef = React.useRef(null);
  //console.log("start Loading")

  Modal.setAppElement('body')

  useEffect(() => {
    if (isOpen !== open) {
      setOpen(isOpen);
    }
  }, [isOpen, open])

  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);



  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)'
    }
  };


  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
    sOpen(false)
  };

  return (
    <Dialog
      disableEscapeKeyDown={true}
      disableBackdropClick={true}
      open={open}
      fullWidth={true}
      maxWidth={"sm"}

      onClose={handleClose}
      scroll={scroll}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle id="scroll-dialog-title" >
        {title}
      </DialogTitle>
      <DialogContent dividers={scroll === 'paper'}>
        {content}
      </DialogContent>
      <DialogActions>
        {action}
        {/* <Button onClick={handleClose} color="primary">
    Cancel
      </Button>
  <Button onClick={handleClose} color="primary">
    Subscribe
      </Button> */}
      </DialogActions>
    </Dialog>
  )
}